import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { getLatestUpdates } from '@/mocks/manga';

export default function LatestSection() {
  const latestManga = getLatestUpdates(8);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              每日更新的<strong>耽美漫画免费看</strong>资源
            </p>
          </div>
          <Link
            to="/category/gu-feng"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestManga.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}